import { MASK_TOKEN_NAME, MASK_CURRENT_MODULE, CACHE_SET_STORAGE } from './constants.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getToken = () => {
  return window.sessionStorage.getItem(MASK_TOKEN_NAME);
};
const updateToken = token => {
  window.sessionStorage.setItem(MASK_TOKEN_NAME, token);
  localStorage.setItem(CACHE_SET_STORAGE, JSON.stringify(sessionStorage));
  localStorage.removeItem(CACHE_SET_STORAGE);
};
const getMaskToken = () => {
  const token = getToken();
  if (token) {
    return JSON.parse(token);
  }
};
const checkMaskToken = () => {
  const token = getMaskToken();
  if (token) {
    if (token.token && token.unMasking) {
      return token;
    }
  }
};
const updateMaskToken = token => {
  const maskToken = {
    featureCode: token.featureCode,
    unMasking: token.unMasking,
    token: token.token,
    expiryAt: token.expiryAt,
    tokentype: token.tokentype
  };
  updateToken(JSON.stringify(maskToken));
};
const removeMaskToken = () => {
  const token = getMaskToken();
  if (token) {
    const maskToken = __spreadProps(__spreadValues({}, token), {
      unMasking: false
    });
    updateMaskToken(maskToken);
  }
};
const clearMaskToken = () => {
  sessionStorage.removeItem(MASK_TOKEN_NAME);
};
const updateCurrentModule = moduleName => {
  localStorage.setItem(MASK_CURRENT_MODULE, moduleName || "");
};
const formatLeftTime = leftTime => {
  const minutes = Math.floor(leftTime / 60);
  const seconds = Math.floor(leftTime % 60);
  return "".concat(minutes.toString(), ":").concat(seconds.toString().padStart(2, "0"), " minutes");
};
const checkMaskTokenExpiry = () => {
  const maskToken = sessionStorage.getItem(MASK_TOKEN_NAME);
  if (maskToken) {
    const token = JSON.parse(maskToken);
    const expiryAt = token.expiryAt;
    if (!expiryAt || Number(token.expiryAt) - 20 * 1e3 < /* @__PURE__ */new Date().getTime()) {
      clearMaskToken();
    }
  }
};
export { checkMaskToken, checkMaskTokenExpiry, clearMaskToken, formatLeftTime, getMaskToken, removeMaskToken, updateCurrentModule, updateMaskToken };